
import React from 'react';
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';

import './CobGrid.css';

class CobGrid extends ResponsiveGrid {

    get containerProps() {
        const containerProps = super.containerProps;
        containerProps.className = `COB-Grid aem-Grid aem-Grid--12 aem-Grid--default--12 gutter-padding ${this.props.singleGrid ? 'gutter-padding--noPaddingDesktop' : ''}`;
        return containerProps;
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div {...this.containerProps}>
                { this.childComponents }
                { super.placeholderComponent }
            </div>
        );
    }
}

export default CobGrid;
